<template>
  <div class="w-16 flex flex-col items-center">
    <div
      class="relative w-10 h-4 rounded-3xl custom-transition bg-gray-300"
      :class="{
        '!bg-green-500': props.value && props.colour === 'green',
        '!bg-red-400': props.value && props.colour === 'red',
        '!bg-gray-300': !props.value && props.colour,
      }"
      @click.stop="toggleValue()"
    >
      <!--
        <button
        class="w-[14px] h-[14px] -top-[3px] rounded-full bg-black relative cursor-pointer custom-transition"
        :class="props.value ? 'left-3' : '-left-3'"
        @click.stop="toggleValue()"
      ></button>
      -->
      <button
        class="absolute top-[1px] left-[1px] w-[14px] h-[14px] rounded-full bg-black cursor-pointer custom-transition will-change-transform"
        :class="props.value ? 'translate-x-[24px]' : 'translate-x-0'"
        @click.stop="toggleValue()"
        type="button"
        :aria-pressed="props.value"
      ></button>    

    </div>
    <p
      class="text-xs w-full pt-1 cursor-default"
      :class="{
        'text-green-500': props.value && props.colour === 'green',
        'text-red-400': props.value && props.colour === 'red',
        'text-gray-300': !props.value && props.colour,
      }"
    >
      {{ props.value ? props.message.on : props.message.off }}
    </p>
  </div>
</template>

<script setup lang="ts">
  import { PropType } from 'vue'

  interface ToggleMessage {
    on: string
    off: string
  }

  const props = defineProps({
    value: { type: Boolean, required: true },
    colour: { type: String, default: 'green' }, // 'green', or 'red'
    message: { type: Object as PropType<ToggleMessage>, default: {} },
  })

  const emit = defineEmits<{
    (e: 'toggleValue', value: boolean): void
  }>()

  const toggleValue = () => {
    emit('toggleValue', !props.value)
  }
</script>

<style lang="css" scoped>
  .custom-transition {
    transition: 0.3s ease-in-out;
  }
</style>

/* Firefox friendly styling for button */
button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
